import ReactEChartsCore from 'echarts-for-react/lib/core';
import { ScatterChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import {
  breakpointsMediaQuery,
  getColor,
  getRandomColor,
  tooltipFormatter,
  useMediaQuery
} from '@/helpers/utils';
import { Card, Col, Row } from 'react-bootstrap';
import { useRef } from 'react';
import { serpTooltips } from '@/app/Serp/tooltip/serpTooltips';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import CardChartDropDown from '@/components/common/CardChartDropDown';
import CustomLegent from '@/app/common/components/charts/CustomLegent';
import timeStampToDate from '@/helpers/timeStampToDate';
import numberHumanizer from '@/helpers/numberHumanizer';
import { useTooltipHide } from '@/hooks/useTooltipHide';
echarts.use([ScatterChart, TooltipComponent, GridComponent, LegendComponent]);

const CompetitorsAvgRank = ({ data }) => {
  const cardRef = useRef();
  const chartRef = useRef();
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);
  const dates = data?.dates.map(time => timeStampToDate(time).slice(8));
  const formattedSeries = Object.entries(data?.competitors)?.map(
    ([name, value], i) => {
      const c = getRandomColor(i);
      return {
        type: 'line',
        smooth: false,
        name,
        data: value,
        symbol: 'emptyCircle',
        itemStyle: {
          color: getColor(c)
        },
        lineStyle: {
          color: getColor(c)
        },

        emphasis: {
          lineStyle: {
            width: 2
          }
        }
      };
    }
  );

  // تنظیمات نمودار
  const getOption = () => ({
    grid: { right: '5%', left: '5%', bottom: 60, top: '5%' },
    textStyle: {
      fontFamily: 'dana'
    },
    legend: {
      show: false
    },
    tooltip: {
      triggerOn: isMdUp ? 'mousemove' : 'click',
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100') },
      borderWidth: 1,
      formatter: params => {
        const formattedParams = params
          ?.map(({ seriesName, value, marker }) => {
            return `<span class="d-flex justify-content-between flex-md-row flex-column" style="direction:ltr;margin:0;padding:0"><span class="fw-bolder">${marker} ${seriesName.toPersianDigit()}:</span> ${numberHumanizer(value)?.toString()?.toPersianDigit() || 'نامشخص'}</span>`;
          })
          ?.join('');
        return `
        <div style="font-family: dana !important;">
        <div class="mb-2 d-flex gap-1">
        <span class="d-none d-md-block">رتبه در </span><span class="fw-bold">${params[0]?.axisValue?.toPersianDigit()}</span>
        </div>  
        <div style="direction:rtl;" class="d-flex flex-column">
          ${formattedParams}  
          </div>
        </div>`;
      },
      transitionDuration: 0,
      axisPointer: {
        // type: 'shadow'
      }
    },
    xAxis: {
      //   name: 'تاریخ به‌روزرسانی',
      //   nameLocation: 'center',
      //   nameTextStyle: { color: getColor('gray-900'), padding: 3 },
      data: dates,
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        interval: false,
        rotate: -45, // Rotate the labels by -45 degrees
        margin: 10
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      }
    },
    yAxis: {
      inverse: true,
      name: 'رتبه',
      nameLocation: 'center',
      nameTextStyle: { color: getColor('gray-900'), padding: 15 },

      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        margin: 5
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      }
    },
    series: formattedSeries
  });
  return (
    <Card className="mb-3 px-0" ref={cardRef}>
      <FalconCardHeader
        title={<div>میانگین رتبه رقبا </div>}
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body className="px-3">
        <ReactEChartsCore
          ref={chartRef}
          echarts={echarts}
          option={getOption()}
          style={{ height: '23rem' }}
        />
        <div className="d-flex gap-2 flex-wrap justify-content-center align-items-center">
          {formattedSeries.map(item => (
            <CustomLegent
              chartRef={chartRef}
              name={item.name}
              color={item.itemStyle.color}
              key={item.name}
            />
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};
export default CompetitorsAvgRank;
